import queryString from "query-string";
import { pickBy } from "../../common/helpres/lib";
import { membersLink, signinLink, tokenLink } from "../../credentials/consts/links";
import { getAuthorizationHeader, getSessionAuthorizationHeader, setBearerTokenToStorage, } from "./bearerToken";
export const tokenExpiredEventName = "TOKEN_EXPIRED";
export const tokenExpiredEvent = new Event(tokenExpiredEventName);
export class FetchError extends Error {
    constructor(message, responseCode, result) {
        super(message);
        this.message = message;
        this.result = result;
        this.responseStatus = responseCode;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isFile = (arg) => {
    return !!arg.fileBlob;
};
/**
 * Retrieves form data from an object.
 *
 * @template O - The type of the object containing the form data.
 * @param {O} data - The object containing the form data.
 * @returns {FormData} - The FormData object containing the converted form data.
 */
const getFormData = (data) => {
    return Object.keys(data).reduce((formData, key) => {
        const value = data[key];
        if (value && isFile(value)) {
            formData.append(key, value.fileBlob, value.fileName);
        }
        else {
            formData.append(key, String(value));
        }
        return formData;
    }, new FormData());
};
const getBody = (method, params, isFormData = false) => {
    if (method === "GET") {
        return {};
    }
    else {
        return !isFormData ? { body: JSON.stringify(params) } : { body: getFormData(params) };
    }
};
const getUrl = (method, url, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
query) => {
    const baseUrl = `${window.REACT_APP_DOMAIN_URL || ""}${url}`;
    return method === "GET" && query ? queryString.stringifyUrl({ url: baseUrl, query }) : baseUrl;
};
export const getFetchParams = async (request) => {
    const newHeaders = {
        ...(!request.isFormData
            ? { Accept: "application/json", "Content-Type": "application/json" }
            : {}),
        ...(!request.accountId ? {} : await getAuthorizationHeader(request.accountId)),
        ...(!request.useSessionAccountId ? {} : await getSessionAuthorizationHeader()),
        ...request.headers,
    };
    /// TODO - REMOVE IT AFTER IDASH-3192 PADP INTEGRATION WILL BE DONE
    const { query } = queryString.parseUrl(window.location.href);
    if (request.url.includes("/api/v2/widgets/") && query.padp) {
        request.url = queryString.stringifyUrl({ url: request.url, query: { padp: query.padp } });
    }
    ///
    const url = getUrl(request.method || "GET", request.url, request.params && typeof request.params === "object" ? request.params : {});
    const body = {
        method: request.method,
        ...getBody(request.method || "GET", (request.params || {}), request.isFormData),
        credentials: request.withCredentials ? "include" : "same-origin",
        headers: pickBy(newHeaders, (v) => v !== undefined),
        signal: request.signal,
    };
    return { url, body };
};
export const getFetchResult = async (response, request) => {
    let data;
    if (checkIsExtension()) {
        data = response.data;
    }
    else {
        data =
            await response[response.headers.get("Content-Type")?.includes("application/json") ? "json" : "text"]();
    }
    if (!response.ok) {
        if (response.status === 401 &&
            !request.ignore401 &&
            request.url.includes(window.location.hostname)) {
            setBearerTokenToStorage("");
            !checkIsExtension() && redirectToSignIn();
        }
        else if (response.status === 401 && !request.ignore401 && !request.url.includes(tokenLink)) {
            window.dispatchEvent(tokenExpiredEvent);
        }
        if (response.status === 401 && checkIsExtension()) {
            chrome?.storage?.sync.set({ isUserLogged: false });
        }
        throw new FetchError(data.message, response.status, data);
    }
    const result = request.showHttpData
        ? {
            data,
            __httpData: {
                status: response.status,
                statusText: response.statusText,
            },
        }
        : data;
    return { result, data };
};
export const redirectToSignIn = () => {
    window.location.assign(`${membersLink}${signinLink}?re=${window.btoa(window.location.host.includes(":") || window.location.origin.includes(membersLink)
        ? window.location.pathname
        : window.location.href)}`);
};
export const checkIsExtension = () => window.chrome && !!window.chrome?.runtime?.getManifest?.();
